export default __webpack_public_path__ + "static/media/Coin S Stack Solid 1.0ce74eb6.png";